import React from 'react';
import './styles.scss';

const LoadingIndicator = () => (
  <div className="button-overlay-spinner">
    <div className="loader">
      <svg className="circular" viewBox="25 25 50 50">
        <circle className="path" cx={50} cy={50} r={20} fill="none" strokeWidth="2" strokeMiterlimit="10"/>
      </svg>
    </div>
  </div>
);

export default LoadingIndicator;



/** WEBPACK FOOTER **
 ** ../components/ButtonSpinner/index.js
 **/